// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductVideoTab_container__20cgz","inputWrap":"ProductVideoTab_inputWrap__39zve","input":"ProductVideoTab_input__3P7fG","button":"ProductVideoTab_button__35iEA"};